export const INITIALIZE_SAVE_THE_DATE_STATE = 'INITIALIZE_SAVE_THE_DATE_STATE';
export const SAVE_ECARD_DRAFT = 'SAVE_ECARD_DRAFT';
export const TOGGLE_IS_NAV_BAR_OPEN = 'TOGGLE_IS_NAVBAR_OPEN';
export const SEND_EMAIL = 'SEND_EMAIL';
export const SAVE_EMAIL_DRAFT = 'SAVE_EMAIL_DRAFT';
export const TOGGLE_IS_ADJUSTING_POSITION = 'TOGGLE_IS_ADJUSTING_POSITION';
export const TOGGLE_EDIT_PANEL = 'TOGGLE_EDIT_PANEL';
